import { sanitizeVariableName } from "../../../utils/formulaScope";
import type { LaborFormulas } from "../../../hooks/query";
import type { LaborFormulaFlag, LaborRowItem } from "../types";
import {
    evaluateFormula,
    getFormulaVariables,
    substituteFormulaExpression,
} from "./evaluateFormula";

function applyOutputFormat(
    value: number,
    outputFormat?: "WholeNumber" | "Decimal",
): number {
    if (outputFormat === "WholeNumber") {
        return Math.round(value);
    }
    return value;
}

function buildFormulaInfo(
    expression: string,
    scope: Record<string, any>,
    outputFormat?: "WholeNumber" | "Decimal",
): LaborFormulaFlag {
    const variables = getFormulaVariables(expression, scope);
    const substitutedExpression = substituteFormulaExpression(expression, scope);
    const raw = evaluateFormula(expression, scope);
    const result = applyOutputFormat(raw, outputFormat);

    return {
        hasFormula: true,
        formulaActive: true,
        expression,
        variables,
        substitutedExpression,
        result,
    };
}

export function calculateLaborQuantities(
    scope: Record<string, any>,
    formulas: LaborFormulas | undefined,
    laborRows: LaborRowItem[],
) {
    const quantities: Record<string, number> = {};
    const formulaInfo: Record<string, LaborFormulaFlag> = {};
    const workingScope = { ...scope };

    for (const row of laborRows) {
        const config = formulas?.[row.name];
        const expression = config?.expression?.trim();

        if (!expression) {
            formulaInfo[row.id] = { hasFormula: false, formulaActive: false };
            continue;
        }

        const info = buildFormulaInfo(
            expression,
            workingScope,
            config?.outputFormat,
        );
        formulaInfo[row.id] = info;
        quantities[row.id] = info.result ?? 0;
        workingScope[sanitizeVariableName(row.name)] = info.result ?? 0;
    }

    return { quantities, formulaInfo };
}
